import {ReactElement} from "react"

const PlusIcon = ({stroke = "#7E8591"}: {stroke: string}): ReactElement => {
	return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 8.75H8.75M8.75 8.75H16.75M8.75 8.75V16.75M8.75 8.75V0.75"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"/>
    </svg>
  )
}

export default PlusIcon
